import {CommonModule} from '@angular/common';
import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgxsReduxDevtoolsPluginModule} from '@ngxs/devtools-plugin';
import {NgxsStoragePluginModule, StorageOption} from '@ngxs/storage-plugin';
import {NgxsModule} from '@ngxs/store';
import {AuthConfig, OAuthModule, OAuthModuleConfig, OAuthStorage, ValidationHandler} from 'angular-oauth2-oidc';
import {JwksValidationHandler} from 'angular-oauth2-oidc-jwks';
import {ToastModule} from 'primeng/toast';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {URL_TOKEN} from './core/services/graphql-client.service';
import {appStore} from './core/store/appStore';
import {PanelOutputsModule} from './panel-outputs/panel-outputs.module';
import {AngularMaterialModule} from './scss/angular-material/angular-material.module';
import {envServiceProvider} from './services/envServiceProvider';
import {SharedModule} from './shared/shared.module';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import {ErrorHandlerService} from './services/errorHandler.service';
import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {ConfirmationService} from 'primeng/api';
// optional, provides moment-style pipes for date formatting

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    ToastModule,
    //move to sharedModule
    AngularMaterialModule,
    BrowserAnimationsModule,
    PanelOutputsModule,
    CommonModule,
    SharedModule,
    //rootStoreModule
    NgIdleKeepaliveModule.forRoot(),
    NgxsModule.forRoot(appStore),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    // NgxsLoggerPluginModule.forRoot({ disabled: environment.production }),
    NgxsStoragePluginModule.forRoot({
      key: ['shared.notificationSettings'],
      storage: StorageOption.SessionStorage
    }),
    //rootStore module end.

    //move to core, import core once to app module
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: ['https://localhost:6001/api/access-points'],
        sendAccessToken: true
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  //providers are added in core module and imported to app module.
  providers: [
    envServiceProvider,
    ConfirmationService,
    {provide: OAuthModuleConfig, useValue: envServiceProvider.useFactory().authConfig},
    {provide: ValidationHandler, useClass: JwksValidationHandler},
    {provide: OAuthStorage, useValue: localStorage},
    {provide: AuthConfig, useExisting: OAuthModuleConfig},
    {provide: URL_TOKEN, useValue: envServiceProvider.useFactory().environment?.gatewayUrls?.graphqlBaseEndpoint},
    { provide: ErrorHandler, useClass: ErrorHandlerService }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
